module.exports = __webpack_public_path__ + "static/media/events-platform.87f9e824.jpg";